export default __webpack_public_path__ + "static/media/organic-000000.eca0f5a1.png";